import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { HackSearch } from '../components/HackSearch';
import HackFilters from "@/components/HackFilters";
import { getHacks } from "@/services/hackService";
import { HackFilter } from "@/types";

interface LocationState {
  submissionSuccess?: boolean;
}

const Browse = () => {
  const [filters, setFilters] = useState<HackFilter>({
    search: '',
    category: '',
    testingStatus: ''
  });
  const location = useLocation();
  const locationState = location.state as LocationState;
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);

  useEffect(() => {
    // Check if user was redirected after a successful submission
    if (locationState?.submissionSuccess) {
      setShowSuccessMessage(true);
      // Remove the state after showing the message
      window.history.replaceState({}, document.title);
      // Hide the message after 5 seconds
      const timer = setTimeout(() => {
        setShowSuccessMessage(false);
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [locationState]);

  const handleFilterChange = (newFilters: HackFilter) => {
    setFilters(newFilters);
  };

  return (
    <div className="min-h-screen flex flex-col">
      <main className="flex-grow container mx-auto px-4 py-6">
        <h1 className="text-2xl font-bold mb-6">Browse Disability Hacks</h1>
        
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-1">
            <div className="bg-white p-4 rounded shadow-sm mb-6">
              <HackFilters filters={filters} onFilterChange={handleFilterChange} />
            </div>
          </div>
          
          <div className="lg:col-span-3">
            {showSuccessMessage && (
              <div className="bg-green-50 border border-green-200 rounded-md p-4 mb-8">
                <div className="flex">
                  <div className="flex-shrink-0">
                    <svg className="h-5 w-5 text-green-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <div className="ml-3">
                    <h3 className="text-sm font-medium text-green-800">Submission successful!</h3>
                    <div className="mt-2 text-sm text-green-700">
                      <p>Your hack has been submitted and is now awaiting review. Thank you for your contribution!</p>
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div className="flex justify-between items-center mb-6">
              <h2 className="font-semibold">All Disability Hacks</h2>
              
        
            </div>

            {/* Let HackSearch component handle the search and display */}
            <HackSearch isHomePage={false} />
          </div>
        </div>
      </main>
      {/* Footer is included in App.tsx layout */}
    </div>
  );
};

export default Browse;
